import { Component, Input } from '@angular/core';
import { DomSanitizer } from '@angular/platform-browser';
import * as _ from 'lodash';

/**
 * Generated class for the AdTakeoverComponent component.
 *
 * See https://angular.io/api/core/Component for more info on Angular
 * Components.
 */
@Component({
  selector: 'ad-takeover',
  templateUrl: 'ad-takeover.html',
})
export class AdTakeoverComponent {
  @Input() options;

  lastUrl;
  sanitizedUrl;
  forceHide = false;
  eventListener;

  constructor(public sanitizer: DomSanitizer) {}

  ngOnChanges() {
    const url = _.get(this.options, 'url');

    if (url === this.lastUrl) return;

    this.lastUrl = url;

    this.sanitizedUrl = this.sanitizer.bypassSecurityTrustResourceUrl(url);
  }

  loaded(frame) {
    const id = 'ato-' + Math.random();
    frame.contentWindow.postMessage(
      JSON.stringify({
        event: 'init',
        id: id,
      }),
      '*'
    );

    if (this.eventListener) {
      window.removeEventListener('message', this.eventListener);
    }

    this.eventListener = e => {
      try {
        const data = JSON.parse(e.data);

        if (data.childId !== id) return;

        console.warn('GOT EVNET', data);

        if (data.event === 'empty') {
          this.forceHide = true;
        }
      } catch (e) {}
    };

    window.addEventListener('message', this.eventListener);
  }

  ngOnDestroy() {
    window.removeEventListener('message', this.eventListener);
  }
}



// WEBPACK FOOTER //
// ./src/components/ad-takeover/ad-takeover.ts